import React from 'react';
import '../styles/app.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; 2025 上下文工程六要素小工具. 保留所有权利.</p>
      </div>
    </footer>
  );
};

export default Footer;
